import { makeStyles } from 'tss-react/mui';
import { red, green, lightGreen, yellow, amber, blue, grey, orange, purple } from '@mui/material/colors';

const useStyles = makeStyles()(() => ({
    default: {
        color: grey[200],
        backgroundColor: grey[500],
        fontWeight: 'bold'
    },
    Adjusted: {
        color: grey[800],
        backgroundColor: yellow[400]
    },
    Initiated: {
        backgroundColor: blue[500]
    },
    Initialized: {
        backgroundColor: blue[500]
    },
    PaymentInitiated: {
        color: grey[800],
        backgroundColor: yellow[400]
    },
    PaymentProcessed: {
        color: grey[800],
        backgroundColor: lightGreen[400]
    },
    PaymentRefused: {
        backgroundColor: red[400]
    },
    Canceled: {
        backgroundColor: red[400]
    },
    Rejected: {
        backgroundColor: red[900]
    }, 
    Cancelled: {
        backgroundColor: red[400]
    },  
    Error: {
        backgroundColor: red[700]
    }, 
    InvoicedWithErrors: {
        color: grey[800],
        backgroundColor: yellow[400]
    }, 
    Invoiced: {
        backgroundColor: green[400]
    },
    Approved: {
        backgroundColor: green[400]
    },
    Replaced: {
        color: grey[800],
        backgroundColor: orange[300]
    },
    InvoiceProcessing: {
        color: grey[800],
        backgroundColor: orange[300]
    },
    Voided: {
        backgroundColor: purple[300]
    },
    PartiallyVoided: {
        color: grey[800],
        backgroundColor: amber[300]
    },
    Refunded: {
        backgroundColor: purple[300]
    },
    PartiallyRefunded: {
        color: grey[800],
        backgroundColor: amber[300]
    },
    // Stock Movements
    Created: {
        backgroundColor: blue[500]
    },
    Accepted: {
        backgroundColor: green[400]
    },
    Pending: {
        backgroundColor: blue[500]
    },
    Changed: {
        backgroundColor: orange[500]
    },
    NotRemitted: {
        backgroundColor: yellow[500],
        color: grey[800],
        fontWeight: 500
    },
    Remitted: {
        backgroundColor: blue[500],
        fontWeight: 500
    },
    Delivered: {
        backgroundColor: green[400],
        fontWeight: 500
    },
    OperationProcessing: {
        backgroundColor: grey[600]
    },
    OperationRejected: {
        backgroundColor: red.A700
    }
}));

export default useStyles;